// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/diurnal-temperature-variation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/diurnal-temperature-variation/diurnal-temperature-variation.js';

mount([g0]);
